@use '../../../app/styles/common/mixins';

// Figma desktop: 32px between the text block and the «Хорошо» button (Modal defaults to 20).
.modal .container {
  @include mixins.laptop {
    gap: var(--spacing32);
  }
}

// Mobile-first: Figma bottom sheet has a 220px cover, the 632px desktop modal a 356px one.
.cover {
  position: relative;
  height: 220px;
  background: var(--surface-00);
  overflow: hidden;

  @include mixins.laptop {
    height: 356px;
  }

  // `.cover img` (0,2,0) beats Modal's `.modalCover img { width: 100% }` (0,1,1).
  .loop {
    position: absolute;
    top: 34px;
    left: -17px;
    width: 462px;
    max-width: none;
    height: auto;

    @include mixins.laptop {
      top: 55px;
      left: -28px;
      width: 749px;
    }
  }

  .box {
    position: absolute;
    top: calc(50% - 10px);
    left: 50%;
    width: 190px;
    height: auto;
    transform: translate(-50%, -50%);

    @include mixins.laptop {
      top: calc(50% - 16px);
      width: 308px;
    }
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing08);
  width: 100%;

  // Headline's `.h2` switches to heading-accent-600 on tablet+; Figma keeps 20/24 here.
  .title {
    color: var(--fg-primary);

    @include mixins.heading-primary-400;
  }

  // Text's `.text.default` is 0,2,0 — the qualifying `p` makes this 0,2,1.
  p.description {
    color: var(--fg-primary);

    @include mixins.body-primary-400;
  }
}
